export function SubscriptionHelp() {
  return (
    <details className="subscription-help">
      <summary>Help adding this calendar</summary>
      <p>
        Subscribe using the address above to receive future changes. Downloading and importing a
        file creates a one-time copy.
      </p>
      <ul>
        <li>
          <strong>Google Calendar and Android:</strong> on a computer, open Google Calendar and
          choose Other calendars, Add, then From URL. Paste the subscription address. Use the same
          Google account on your phone and enable the new calendar.{' '}
          <a
            href="https://support.google.com/calendar/answer/37100?hl=en"
            target="_blank"
            rel="noreferrer"
          >
            Google instructions
          </a>
        </li>
        <li>
          <strong>Outlook:</strong> choose Add calendar, then Subscribe from web, and paste the
          address.{' '}
          <a
            href="https://learn.microsoft.com/en-us/troubleshoot/outlook/calendaring/cannot-add-an-internet-calendar"
            target="_blank"
            rel="noreferrer"
          >
            Microsoft instructions
          </a>
        </li>
        <li>
          <strong>Apple Calendar:</strong> use the Apple Calendar button, or add a subscription in
          Calendar and paste the address.{' '}
          <a href="https://support.apple.com/en-us/102301" target="_blank" rel="noreferrer">
            Apple instructions
          </a>
        </li>
      </ul>
      <p>
        Your calendar app controls refresh timing, so changes may not appear immediately. The web
        calendar shows current information. This feed includes saved published and cancelled events
        from the calendars you select; private access is checked whenever the app refreshes.
      </p>
      <p>
        The subscription address lets your chosen calendar provider read these events. Keep
        private-calendar addresses out of public posts and shared documents.
      </p>
    </details>
  );
}
